var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderProductViewActivitiesExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9318 11.0459C28.9318 11.0459 30.7001 11.7222 33.9501 14.9722C37.1881 18.2103 37.8672 19.9816 37.8721 19.9945C37.951 21.5376 38 23.342 38 25.4444C38 31.7173 37.5641 35.3381 37.1972 37.2749C36.9614 38.5192 35.9906 39.372 34.7314 39.5078C33.0319 39.6912 30.0328 39.8889 25 39.8889C19.9672 39.8889 16.9681 39.6912 15.2686 39.5078C14.0095 39.372 13.0386 38.5192 12.8028 37.2749C12.4359 35.3381 12 31.7173 12 25.4444C12 19.1716 12.4359 15.5508 12.8028 13.614C13.0386 12.3697 14.0095 11.5169 15.2686 11.381C16.9681 11.1976 19.9672 11 25 11C26.4803 11 27.7847 11.0171 28.9318 11.0459Z",
    fill: "#9DB6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 31.9444C17.7778 32.7422 18.4245 33.3889 19.2222 33.3889H29.3333C30.1311 33.3889 30.7778 32.7422 30.7778 31.9444C30.7778 31.1467 30.1311 30.5 29.3333 30.5H19.2222C18.4245 30.5 17.7778 31.1467 17.7778 31.9444Z",
    fill: "#294C94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 25.4444C17.7778 26.2422 18.4245 26.8889 19.2222 26.8889H25C25.7978 26.8889 26.4445 26.2422 26.4445 25.4444C26.4445 24.6467 25.7978 24 25 24H19.2222C18.4245 24 17.7778 24.6467 17.7778 25.4444Z",
    fill: "#294C94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8721 19.9945C35.7925 20.5176 33.3371 20.5523 31.2163 19.9044C30.3196 19.6305 29.6205 18.932 29.3179 18.0447C28.564 15.8342 28.3778 13.1285 28.9319 11.0458C28.9319 11.0458 30.7 11.7221 33.95 14.9721C37.2 18.2221 37.8721 19.9945 37.8721 19.9945Z",
    fill: "#294C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProductViewActivitiesExplorer);
export default __webpack_public_path__ + "static/media/HeaderProductViewActivitiesExplorer.d3327c5a2205c56a673e9c39ba2ba31f.svg";
export { ForwardRef as ReactComponent };